import { axios } from "../lib";
// import queryString from "query-string";

import * as endpoints from "./apiEndpoints";
import { customToast as toast } from "../utils";

class PtoRequestService {
  static get(body) {
    return axios
      .get(`${endpoints.BASE_URL}${endpoints.PTOREQUESTS}?${body}`)
      .then((res) => res.data)
      .catch((err) => {
        toast.error(err.message);
      });
  }

  static getByUser(body) {
    return axios
      .get(`${endpoints.BASE_URL}${endpoints.PTOREQUESTS}/user?${body}`)
      .then((res) => res.data)
      .catch((err) => {
        toast.error(err.message);
      });
  }

  static put(url) {
    return axios
      .put(`${endpoints.BASE_URL}${endpoints.PTOREQUESTS}${url}`)
      .then((res) => res.data)
      .catch((err) => {
        toast.error(err.message);
      });
  }

  static getPtoRequest(id) {
    const url = `${endpoints.BASE_URL}${endpoints.PTOREQUESTS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createPtoRequest(ptoRequest) {
    const url = `${endpoints.BASE_URL}${endpoints.PTOREQUESTS}`;
    const body = {
      ptoRequest
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updatePtoRequest(ptoRequest) {
    const url = `${endpoints.BASE_URL}${endpoints.PTOREQUESTS}/${ptoRequest._id}`;
    const body = {
      ptoRequest
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deletePtoRequest(id) {
    const url = `${endpoints.BASE_URL}${endpoints.PTOREQUESTS}/${id}`;
    return axios.delete(url).then((response) => response.data);
  }

  static getPtoRequestBalance(id) {
    const url = `${endpoints.BASE_URL}${endpoints.PTOREQUESTS}/balance/${id}`;
    return axios.get(url).then((response) => response.data);
  }
}

export default PtoRequestService;
